var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"navbar",attrs:{"mode":"horizontal"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.handleSignout}},[_vm._v(" "+_vm._s(_vm.handleCommon('setting.signout'))+" "+_vm._s(this.$store.state.signin.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }